import _ from 'lodash';
import { createSearchModifiedTracker } from 'arbitrip-common/general/utils/SearchModifiedTracker';

function normalizeSearchTerms(terms) {
    if (!terms) {
        return null;
    }

    const destination = terms.destination || {};
    const destinationIdentity = _.get(destination, 'place.id') || _.get(destination, 'place.place_id') || destination.address || null;

    return {
        destination_identity: destinationIdentity,
        check_in: terms.check_in ? String(terms.check_in) : null,
        check_out: terms.check_out ? String(terms.check_out) : null,
        guests: terms.guests ?? null,
        rooms: terms.rooms ?? null,
        children_ages: Array.isArray(terms.children_ages) ? terms.children_ages.slice().sort() : [],
    };
}

const tracker = createSearchModifiedTracker(normalizeSearchTerms);

export function captureInitialSearchTerms(terms) {
    tracker.capture(terms);
}

export function isSearchModified(currentTerms) {
    return tracker.isModified(currentTerms);
}
